import { Creators as ProfileCreators } from "model/profileModal"
import { getFilterableCategories } from "selectors/factors"
import { getMustAggregateFactors } from "modules/portfolio-root/selectors/portfolios"
import createModule from "../createModule"
import view from "./view"
import { getTopFactors, getMax, getCategory } from "./selectors"
import { Creators } from "./model"
import { MODEL_METADATA_QUERY } from "resources/models"

export default createModule({
  view,
  externalProps: state => ({
    account: state.global.selected.account,
  }),
  required: ["account", "modelId"],
  data: [
    MODEL_METADATA_QUERY,
  ],
  mapStateToProps: (state, props) => ({
    topFactors: getTopFactors(state, props),
    max: getMax(state, props),
    category: getCategory(state, props),
    categories: getFilterableCategories(state, props),
    hasAggregatedFactors: getMustAggregateFactors(state),
  }),
  actions: {
    openFactorProfile: ProfileCreators.openFactorProfile,
    ...Creators,
  },
})
